export default {
  functions: [
    {
      name: 'getCOPCartItems',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'copCartItems',
      },
    },
  ],
};
